import {useLayoutEffect, useRef} from "react";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Animate = ({
                   children,
                   direction = null,
                   duration = 0.6,
                   delay = 0.2,
                   distance = 100,
                   scrollTriggerStart = 'top bottom'
                 }) => {
  let componentRef = useRef(null);
  let fadeDirection;
  let fadeToDirection;
  switch (direction) {
    case "left":
      fadeDirection = {x: distance};
      break;
    case "right":
      fadeDirection = {x: -distance};
      break;
    case "up":
      fadeDirection = {y: distance};
      break;
    case "down":
      fadeDirection = {y: -distance};
      break;
    default:
      fadeDirection = {x: 0, y: 0};
  }
  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      gsap.from(componentRef.current, {
        scrollTrigger: {
          trigger: componentRef.current,
          start: scrollTriggerStart,
        },
        duration,
        delay,
        opacity: 0,
        // immediateRender: false,
        ...fadeDirection,
      })
      // console.log('Hello')
    });

    return () => ctx.revert();
    // return () => {
    //   _gsap.kill();
    // }
  }, [delay, duration, fadeDirection, fadeToDirection, scrollTriggerStart]);
  return <div ref={componentRef}>{children}</div>;
};

export default Animate
